import { AppState } from './app.state';
import { assetReducer } from './assets/asset.reducers';
import { AnyAction, CombinedState, combineReducers, Reducer } from 'redux';
import { mapReducer } from './maps/map.reducers';
import { chapterReducer } from './chapters/chapter.reducers';
import { colorPickerReducer } from './color-picker/color-picker.reducers';
import { bundleReducer } from './bundles/bundles.reducers';
import { profileReducer } from './profiles/profile.reducers';
import { connectRouter } from 'connected-react-router';
import { regionReducer } from './regions/region.reducers';
import type { History } from 'history';
import { contentTableReducer } from './content-table/content-table.reducers';
import { searchReducer } from './search/search.reducers';
import { bosatlasReducer } from './bosatlas/bosatlas.reducers';
import { httpReducer } from './http/http.reducers';
import { licenceReducer } from './licences/licence.reducers';
import { mapViewerReducer } from './map-viewer/map-viewer.reducers';
import { attachmentEditorReducer } from './attachment-editor/attachment-editor.reducers';
import { snackbarReducer } from './snackbar/snackbar.reducers';
import { mapTextEditorReducer } from './map-text-editor/map-text-editor.reducers';
import { themeReducer } from './themes/theme.reducers';
import { metadataReducer } from './metadata/metadata.reducers';
import { linkChapterReducer } from './linkchapters/linkchapter.reducers';
import { undoableProjectReducer } from './projects/projects.reducers';
import { indexReducer } from './index/index.reducers';
import { comparisonReducer } from './comparisons/comparison.reducers';
import { mapSelectorReducer } from './map-selector/map-selector.reducers';
import { projectSelectorReducer } from './project-selector/project-selector.reducers';
import { legendReducer } from './legend/legend.reducers';
import { userReducer } from './user/user.reducers';
import { ContentManagerReducer as contentManagerReducer } from './content-manager/content-manager.reducers';
import { topographyReducer } from './topography/topography.reducers';
import { multiShareReducer } from './multi-share/multi-share.reducers';

export function createRootReducer(
	history: History
): Reducer<CombinedState<AppState>, AnyAction> {
	return combineReducers<AppState>({
		assets: assetReducer,
		router: connectRouter(history),
		http: httpReducer,
		linkChapters: linkChapterReducer,
		maps: mapReducer,
		chapters: chapterReducer,
		colorPicker: colorPickerReducer,
		profile: profileReducer,
		bundle: bundleReducer,
		bosatlas: bosatlasReducer,
		region: regionReducer,
		contentTable: contentTableReducer,
		search: searchReducer,
		metadata: metadataReducer,
		licences: licenceReducer,
		mapViewer: mapViewerReducer,
		attachmentsEditor: attachmentEditorReducer,
		snackbar: snackbarReducer,
		mapTextEditor: mapTextEditorReducer,
		theme: themeReducer,
		project: undoableProjectReducer,
		index: indexReducer,
		comparisons: comparisonReducer,
		mapSelector: mapSelectorReducer,
		projectSelector: projectSelectorReducer,
		legend: legendReducer,
		user: userReducer,
		contentManager: contentManagerReducer,
		topography: topographyReducer,
		multiShare: multiShareReducer
	});
}
